import { createElement } from 'react';
import { func } from 'prop-types';
import { placementPropType } from '../types/props.js';
import { b as _objectWithoutPropertiesLoose, a as _objectSpread, c as _extends } from '../chunk-ad6ad343.js';
import { Container } from 'reakit';
import _uniqueId from 'lodash/uniqueId';

var initialState = {
  autoDismissTimeout: 5000,
  toasts: []
};

var add = function add(toast) {
  return function (_ref) {
    var setState = _ref.setState,
        state = _ref.state;
    var placement = state.props.placement;

    var key = _uniqueId('toast-');

    var autoDismissTimeout = typeof toast.autoDismissTimeout === 'number' ? toast.autoDismissTimeout : state.autoDismissTimeout;
    setState(function (state) {
      return {
        toasts: [].concat(placement.includes('bottom') ? state.toasts : [], [_objectSpread({
          key: key,
          autoDismissTimeout: autoDismissTimeout
        }, toast)], !placement.includes('bottom') ? state.toasts : [])
      };
    });

    if (autoDismissTimeout > 0) {
      setTimeout(function () {
        return setState(function (state) {
          return {
            toasts: state.toasts.filter(function (toast) {
              return toast.key !== key;
            })
          };
        });
      }, toast.autoDismissTimeout || state.autoDismissTimeout);
    }
  };
};

var effects = {
  add: add,
  info: function info(toast) {
    return add(_objectSpread({}, toast, {
      type: 'info'
    }));
  },
  success: function success(toast) {
    return add(_objectSpread({}, toast, {
      type: 'success'
    }));
  },
  danger: function danger(toast) {
    return add(_objectSpread({}, toast, {
      type: 'danger'
    }));
  },
  warning: function warning(toast) {
    return add(_objectSpread({}, toast, {
      type: 'warning'
    }));
  }
};
var actions = {
  remove: function remove(_ref2) {
    var key = _ref2.key;
    return function (state) {
      return {
        toasts: state.toasts.filter(function (toast) {
          return toast.key !== key;
        })
      };
    };
  }
};
var ToastContainer = function ToastContainer(_ref3) {
  var children = _ref3.children,
      props = _objectWithoutPropertiesLoose(_ref3, ["children"]);

  return createElement(Container, {
    context: "toasts",
    initialState: _objectSpread({}, initialState, {
      props: props
    }),
    actions: actions,
    effects: effects
  }, children);
};
var toastContainerPropTypes = {
  children: func.isRequired,
  placement: placementPropType
};
ToastContainer.propTypes = toastContainerPropTypes;
var toastContainerDefaultProps = {
  placement: 'top-end'
};
ToastContainer.defaultProps = toastContainerDefaultProps;
var withToasts = function withToasts(C) {
  return function (props) {
    return createElement(ToastContainer, null, function (toast) {
      return createElement(C, _extends({
        toast: toast
      }, props));
    });
  };
};

export default ToastContainer;
export { ToastContainer, toastContainerDefaultProps, toastContainerPropTypes, withToasts };
